import React, { useContext } from "react";

import { FreeCashRemovalPopupVariant } from "@swiggy-private/cart-types";

export interface FreeCashRemovalPopupAnalyticsParams {
    warningTrigger: string;
}

export interface FreeCashRemovalPopupConfig {
    variant: FreeCashRemovalPopupVariant;
    onPrimaryClick: VoidFunction;
    onSecondaryClick?: VoidFunction;
    analyticsParams?: FreeCashRemovalPopupAnalyticsParams;
}

export interface FreeCashRemovalPopupContextValue {
    popupConfig: FreeCashRemovalPopupConfig | null;
    showPopup: (config: FreeCashRemovalPopupConfig) => void;
    hidePopup: VoidFunction;
    onPopupImpression: (variant: FreeCashRemovalPopupVariant, analyticsParams: FreeCashRemovalPopupAnalyticsParams) => void;
    onPopupClick: (variant: FreeCashRemovalPopupVariant, userAction: string, analyticsParams: FreeCashRemovalPopupAnalyticsParams) => void;
}

export const INITIAL_FREE_CASH_REMOVAL_POPUP_CONTEXT_VALUE: FreeCashRemovalPopupContextValue = {
    popupConfig: null,
    showPopup: () => void 0,
    hidePopup: () => void 0,
    onPopupImpression: () => void 0,
    onPopupClick: () => void 0,
};

export const FreeCashRemovalPopupContext = React.createContext<FreeCashRemovalPopupContextValue>(
    INITIAL_FREE_CASH_REMOVAL_POPUP_CONTEXT_VALUE,
);

if (__DEV__) {
    FreeCashRemovalPopupContext.displayName = "FreeCashRemovalPopupContext";
}

export function useFreeCashRemovalPopup(): FreeCashRemovalPopupContextValue {
    return useContext(FreeCashRemovalPopupContext);
}
